/*
 * Days and wall-clock times on the user's own clock.
 *
 * `toISOString()` answers in UTC, so between midnight and one or two in the
 * morning in Italy its date is yesterday's. Every `YYYY-MM-DD` the SPA makes
 * for a person comes from here, built from the local fields instead.
 */

const pad = (value: number) => String(value).padStart(2, '0');

/** `YYYY-MM-DD` for the local day `date` falls on. */
export function isoDay(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** Today, in the `YYYY-MM-DD` shape every date field on the wire uses. */
export function today(): string {
  return isoDay(new Date());
}

/** `YYYY-MM-DDTHH:mm`: what a `datetime-local` input wants, not an ISO instant. */
export function localDateTime(date: Date): string {
  return `${isoDay(date)}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function sameDay(a: Date, b: Date): boolean {
  return isoDay(a) === isoDay(b);
}

/** The instant a local day starts, for an API bound that is an instant. */
export function startOfDay(day: string): string {
  return new Date(`${day}T00:00:00`).toISOString();
}

/** The last second of a local day, for an inclusive upper bound. */
export function endOfDay(day: string): string {
  return new Date(`${day}T23:59:59`).toISOString();
}
